import buildService from 'common/utils/build-service'
import { GET } from 'common/requests'

export default buildService({
  type: GET,
  constantsPrefix: 'PHASES',
  isArray: true,
  http: {
    createApiUrlSuffix: () => '/phases?select=id,name',
  },
})
